import React, { useState } from 'react';
const faqs = [{
  q: '¿Qué es el Kit Fiesta Mágica y qué incluye exactamente?',
  a: 'El Kit Fiesta Mágica es una colección digital de +10,000 diseños imprimibles para decoración de fiestas infantiles. Incluye invitaciones, cake toppers, cajas para dulces, banners, stickers, fondos, etiquetas, decoración de candy bar y mucho más. Todo viene en formatos PDF, PNG, SVG y DXF, editables con Canva de forma gratuita. Además, recibes 10 bonos exclusivos al momento de la compra.'
}, {
  q: '¿Cómo recibo el kit? ¿El acceso tiene fecha de vencimiento?',
  a: 'Recibirás un email con el enlace de descarga de forma inmediata tras completar tu pago. El acceso no tiene fecha de vencimiento — una vez que lo descargas, es tuyo para siempre. Puedes usarlo en todas las fiestas que quieras.'
}, {
  q: '¿Necesito experiencia en diseño o programas especiales?',
  a: 'No necesitas ninguna experiencia previa. Los diseños son editables con Canva gratis, que puedes usar desde tu teléfono o computadora sin instalar nada. El kit incluye tutoriales paso a paso para guiarte en todo el proceso.'
}, {
  q: '¿Necesito pagar Canva para usar los diseños?',
  a: 'No. Canva tiene una versión gratuita que es más que suficiente para personalizar todos los diseños del kit. No necesitas la versión premium. Solo creas una cuenta gratis en canva.com y listo.'
}, {
  q: '¿Puedo usar el kit para vender decoraciones o emprender?',
  a: '¡Sí! El kit incluye el Bono 10: Guía Para Emprender con Fiestas, donde te explicamos paso a paso cómo usar estos diseños para ofrecer servicios de decoración en tu ciudad o de forma online. Muchas mamas ya generan ingresos extras con este mismo kit.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-light-pink" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-magenta mb-12 font-baloo" data-id="element-61">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-62">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border-2 border-pink-100 overflow-hidden" data-id="element-63">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-pink-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-64">
                <span className="font-bold text-lg text-gray-800 font-baloo pr-4" data-id="element-65">
                  {faq.q}
                </span>
                <span className={`text-magenta font-bold text-2xl transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-66">
                  +
                </span>
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-67">
                <p className="text-gray-600 leading-relaxed pt-2 border-t border-pink-50" data-id="element-68">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}